import { Button } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'
import config from '../../../../config.json'

import './AutoPaySetDialog.css'

const AutoPaySetDialog = () => {
  const dispatch = useDispatch()
  const isAutoPayDialogVisible = useSelector(
    state => state.payment.isAutoPayDialogVisible
  )

  const isAutoPaySetLoading = useSelector(
    state => state.payment.isAutoPaySetLoading
  )

  const onCancel = () => {
    dispatch(Actions.createAction(Actions.CLOSE_AUTO_PAY_POPUP))
  }

  const dialogActions = [
    <Button
      key="2"
      className="dialog-action tracakble"
      data-name="setAutoPay from dialog"
      type="primary"
      loading={isAutoPaySetLoading}
      onClick={() => {
        dispatch(Actions.createAction(Actions.SET_AUTO_PAY_REQUESTED))
      }}
    >
      {$t('dialogs.autoPay.setUp')}
    </Button>,
    <Button
      key="1"
      className="dialog-action trackable"
      data-name="oneTimePayment from dialog"
      type="secondary"
      disabled={isAutoPaySetLoading}
      onClick={onCancel}
    >
      {$t('dialogs.autoPay.continue')}
    </Button>,
  ]

  return (
    <>
      <Dialog
        title={$t('dialogs.autoPay.title')}
        isVisible={isAutoPayDialogVisible}
        footerActions={dialogActions}
        onCancel={onCancel}
        closable={false}
        className="autopay-dialog"
      >
        <div className="dialog-content">
          <div className="subtitle">{$t('dialogs.autoPay.subtitle')}</div>
          <img
            className="check-image"
            src={config.gcpStorageUrl + '/img/success-check.svg'}
            alt=""
          />
        </div>
      </Dialog>
    </>
  )
}

export default AutoPaySetDialog
